import React from 'react';
import { ChatMonitoring } from '../chat/ChatMonitoring';

export const ChatMonitoringPage: React.FC = () => {
  return <ChatMonitoring />;
};